import { inject, Injectable } from '@angular/core';
import { MenuItem } from '../../../core/interfaces/menu-item.interface';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SidenavMenuItemsService {

  private sidenavMenuItems: MenuItem[] = [];
  private sessionStorageService = inject(SessionStorageService);


  constructor() { }

  // Managers Menu Items.
  getManagersSidenavMenuItems(): MenuItem[] {
    const managersSidenavMenuItems: MenuItem[] = [
      // {
      //   label: "Dashboard Old",
      //   route: "/dashboard",
      //   icon: "dashboard",
      //   badgehidden: true
      // },
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard",
        badgehidden: true
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Agent Onboarding",
        route: "/agent-onboarding",
        icon: "business",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "agent-onboarding/create-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/view-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/edit-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/rmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/bdmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "/agent-onboarding/onboardingnavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsunavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsumanagernavigation-tab",
            // icon: "links",
          },
        ]
      },
      {
        label: "Marketing Review",
        route: "/marketing-review",
        icon: "ads_click",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/marketing-review/create-ad"
          },
          {
            label: "",
            route: "/marketing-review/review-ad"
          },
        ]
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true
      }
      // {
      //   label: "Users",
      //   route: "#",
      //   icon: "people",
      //   isParent: true,
      //   children: [
      //     {
      //       label: "Create New Users",
      //       route: "/user/create-new-user",
      //       icon: "add_circle"
      //     },
      //     {
      //       label: "Manage Users",
      //       route: "/user/manage-user",
      //       icon: "settings"
      //     }
      //   ],
      //   expanded: true
      // }
    ];

    return managersSidenavMenuItems;
  }


  getAdManagersSidenavMenuItems(): MenuItem[] {
    const managersSidenavMenuItems: MenuItem[] = [
      // {
      //   label: "Dashboard Old",
      //   route: "/dashboard",
      //   icon: "dashboard",
      //   badgehidden: true
      // },
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard",
        badgehidden: true
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Agent Onboarding",
        route: "/agent-onboarding",
        icon: "business",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "agent-onboarding/create-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/view-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/edit-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/rmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/bdmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "/agent-onboarding/onboardingnavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsunavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsumanagernavigation-tab",
            // icon: "links",
          },
        ]
      },
      {
        label: "Marketing Review",
        route: "/marketing-review",
        icon: "ads_click",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/marketing-review/create-ad"
          },
          {
            label: "",
            route: "/marketing-review/review-ad"
          },
        ]
      },
      {
        label: "Annual Declaration",
        route: "/annual-declaration/annual-declaration-form",
        icon: "assignment",
        badgehidden: ['Not_Started', 'In_progress', 'Returned'].includes(this.sessionStorageService.getCurrentAdflag()) ? false : true,
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true
      }
      // {
      //   label: "Users",
      //   route: "#",
      //   icon: "people",
      //   isParent: true,
      //   children: [
      //     {
      //       label: "Create New Users",
      //       route: "/user/create-new-user",
      //       icon: "add_circle"
      //     },
      //     {
      //       label: "Manage Users",
      //       route: "/user/manage-user",
      //       icon: "settings"
      //     }
      //   ],
      //   expanded: true
      // }
    ];

    return managersSidenavMenuItems;
  }

  // Agents Menu Items.
  getAgentsSidenavMenuItems(): MenuItem[] {
    const agentsSidenavMenuItems: MenuItem[] = [
      // {
      //   label: "Dashboard Old",
      //   route: "/dashboard",
      //   icon: "dashboard",
      //   badgehidden: true
      // },
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard",
        badgehidden: true
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Agent Onboarding",
        route: "/agent-onboarding",
        icon: "business",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "agent-onboarding/create-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/view-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/edit-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/rmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/bdmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "/agent-onboarding/onboardingnavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsunavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsumanagernavigation-tab",
            // icon: "links",
          },
        ]
      },
      {
        label: "Marketing Review",
        route: "/marketing-review",
        icon: "ads_click",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/marketing-review/create-ad"
          },
          {
            label: "",
            route: "/marketing-review/review-ad"
          },
        ]
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true
      }
    ];

    return agentsSidenavMenuItems;
  }
  getAdAgentsSidenavMenuItems(): MenuItem[] {
    const agentsSidenavMenuItems: MenuItem[] = [
      // {
      //   label: "Dashboard Old",
      //   route: "/dashboard",
      //   icon: "dashboard",
      //   badgehidden: true
      // },
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard",
        badgehidden: true
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Agent Onboarding",
        route: "/agent-onboarding",
        icon: "business",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "agent-onboarding/create-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/view-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/edit-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/rmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/bdmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "/agent-onboarding/onboardingnavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsunavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsumanagernavigation-tab",
            // icon: "links",
          },
        ]
      },
      {
        label: "Marketing Review",
        route: "/marketing-review",
        icon: "ads_click",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/marketing-review/create-ad"
          },
          {
            label: "",
            route: "/marketing-review/review-ad"
          },
        ]
      },
      {
        label: "Annual Declaration",
        route: "/annual-declaration/annual-declaration-form",
        icon: "assignment",
        badgehidden: ['Not_Started', 'In_progress', 'Returned'].includes(this.sessionStorageService.getCurrentAdflag()) ? false : true,
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true
      }
    ];

    return agentsSidenavMenuItems;
  }
  getnewRepSidenavMenuItems(): MenuItem[] {
    const newRepSidenavMenuItems: MenuItem[] = [

      {
        label: "Agent Onboarding",
        route: "/agent-onboarding",
        icon: "business",
        badgehidden: true
      },
    ];
    return newRepSidenavMenuItems;

  }

  getDSUSidenavMenuItems(): MenuItem[] {
    const DSUSidenavMenuItems: MenuItem[] = [
      {
        label: "Agent Onboarding",
        route: "/agent-onboarding",
        icon: "business",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "agent-onboarding/create-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/view-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/edit-onboarding-application",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/rmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "agent-onboarding/bdmnavigation-tab",
            // icon: "add_circle"
          },
          {
            label: "",
            route: "/agent-onboarding/onboardingnavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsunavigation-tab",
            // icon: "links",
          },
          {
            label: "",
            route: "/agent-onboarding/dsumanagernavigation-tab",
            // icon: "links",
          },
        ]
      },
      {
        label: "Annual Declaration",
        route: "/annual-declaration",
        icon: "assignment",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/annual-declaration/dsu-annual-declaration-form",
            // icon: ""
          },
        ]

      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Adviser Maintenance",
        route: "/agent-maintenance",
        icon: "build",
        // badgehidden:['In_Review','Submitted'].includes(this.sessionStorageService.getCurrentAdflag())? false:true,
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/agent-maintenance/maintenance-dashboard",
            // icon: ""
          },
          {
            label: "",
            route: "agent-maintenance/agent-maintenance-form",
          },
        ]

      }
    ];
    return DSUSidenavMenuItems;
  }

  getPASidenavMenuItems(): MenuItem[] {
    const paSidenavMenuItems: MenuItem[] = [
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true,
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true
      }
    ];
    return paSidenavMenuItems;
  }

  // Corporate Menu Items.
  getCorporateSidenavMenuItems(): MenuItem[] {
    const corporateSidenavMenuItems: MenuItem[] = [
      // {
      //   label: "Dashboard Old",
      //   route: "/dashboard",
      //   icon: "dashboard",
      //   badgehidden: true
      // },
      {
        label: "Dashboard",
        route: "/dashboard",
        icon: "dashboard",
        badgehidden: true
      },
      {
        label: "Download Resources",
        route: "/download-resources",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Download Resources New",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true,
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true,
      },
      {
        label: "Campaign",
        route: "/campaign",
        icon: "campaign",
        badgehidden: true,
        isParent: true,
        children: [
          {
            label: "Create Campaign",
            route: "/campaign",
            icon: "add_circle_outline",
            badgehidden: true,
            activeRoutes: ["/campaign/create", "/campaign/detail"]
          },
          {
            label: "Create Template",
            route: "/campaign/manage-template",
            icon: "note_add",
            badgehidden: true,
            activeRoutes: ["/campaign/create-template"]
          }
        ]
      }

    ];

    return corporateSidenavMenuItems;
  }


  // Marketing Review Menu Items.
  getMarketingReviewSidenavMenuItems(): MenuItem[] {
    const MarketingReviewSidenavMenuItems: MenuItem[] = [
      {
        label: "Marketing Review",
        route: "/marketing-review",
        icon: "ads_click",
        badgehidden: true,
        children: [
          {
            label: "",
            route: "/marketing-review/create-ad"
          },
          {
            label: "",
            route: "/marketing-review/review-ad"
          },
        ]
      },
      {
        label: "Download Resources",
        route: "/download-resources-v2",
        icon: "download",
        badgehidden: true
      },
      {
        label: "Events & Training",
        route: "/events-training",
        icon: "info",
        badgehidden: true,
      },
      {
        label: "Quick Links",
        route: "/quick-links",
        icon: "links",
        badgehidden: true,
      },
      {
        label: "Campaign",
        route: "/campaign",
        icon: "campaign",
        badgehidden: true,
        isParent: true,
        children: [
          {
            label: "Create Campaign",
            route: "/campaign",
            icon: "add_circle_outline",
            badgehidden: true,
            activeRoutes: ["/campaign/create", "/campaign/detail"]
          },
          {
            label: "Create Template",
            route: "/campaign/manage-template",
            icon: "note_add",
            badgehidden: true,
            activeRoutes: ["/campaign/create-template"]
          }
        ]
      }
    ];

    return MarketingReviewSidenavMenuItems;

  }


}
